import React, { useState, Fragment } from 'react';

import ChatIcon from '@material-ui/icons/Chat';
import IconButton from '@material-ui/core/IconButton';
import ChatDialog from '../ChatDialog/ChatDialog';


//ChatDialog
//import useFullScreenToggle from '../../../hooks/useFullScreenToggle/useFullScreenToggle';

export default function ChatButton() {
    const [chatOpen, setChatOpen] = useState(false);

    return (
        <Fragment>
            <IconButton color="inherit" onClick={() => { setChatOpen(true) }}>
                <ChatIcon />
            </IconButton>
            <ChatDialog
                open={chatOpen}
                onClose={() => {
                    setChatOpen(false);
                }}
            />
        </Fragment>
    );
}
